import { useSubmitFeedbackMutation } from '@api/feedback';

const useSubmitFeedback = () => {
  const [submitFeedback, { isLoading, isError, isSuccess }] = useSubmitFeedbackMutation();

  const sendFeedback = async (payload: any) => {
    try {
      const response = await submitFeedback(payload).unwrap();
      return response;
    } catch (err) {
      return null;
    }
  };

  return { sendFeedback, isLoading, isError, isSuccess };
};

export default useSubmitFeedback;
